module.exports = "<div class=\"spinner-overlay\" [class.go-hidden]=\"hidden\">\n  <div class=\"spinner-container\" go-spinner [size]=\"size\"></div>\n</div>\n"